var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImg5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 44,
    viewBox: "0 0 40 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 22V34H22V22H18ZM26 34H36C37.0609 34 38.0783 34.4214 38.8284 35.1716C39.5786 35.9217 40 36.9391 40 38V40C40 41.0609 39.5786 42.0783 38.8284 42.8284C38.0783 43.5786 37.0609 44 36 44H4C2.93913 44 1.92172 43.5786 1.17157 42.8284C0.421427 42.0783 0 41.0609 0 40V38C0 36.9391 0.421427 35.9217 1.17157 35.1716C1.92172 34.4214 2.93913 34 4 34H14V18H26V34ZM4 38V40H36V38H4ZM20 16.8C18.4087 16.8 16.8826 16.1679 15.7574 15.0426C14.6321 13.9174 14 12.3913 14 10.8C14 8.59 16 4.99 20 0C24 4.99 26 8.59 26 10.8C26 12.3913 25.3679 13.9174 24.2426 15.0426C23.1174 16.1679 21.5913 16.8 20 16.8ZM20 12.896C21.104 12.896 22 11.936 22 10.896C22 9.964 21.334 8.678 20 6.896C18.666 8.678 18 9.964 18 10.896C18 11.936 18.896 12.896 20 12.896Z",
    fill: "#5C5470"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg5);
export default __webpack_public_path__ + "static/media/img5.02aa7fa938af961476fa7af0e4ba5d2f.svg";
export { ForwardRef as ReactComponent };